import React from 'react';
import step1 from './images/step1.png';
import step2 from './images/step2.png';
import step3 from './images/step3.png';

import styles from './step.module.scss';

export const Step = () => {
    return (
        <div className={styles.container}>
            <h3>¿Qué hacer para comprar reportes?</h3>

            <div className={styles.stepsContainer}>
                <div>
                    <img src={step1} alt="step1" width="100px" height="109px"/>
                    <span>
                        Selecciona la opción <strong>Solicitar Reporte</strong>, ingresa la patente deseada y sigue los pasos.
                    </span>
                </div>

                <div>
                    <img src={step2} alt="step2" width="100px" height="109px"/>
                    <span>
                        <strong>Id-Auto</strong> consulta variadas fuentes de información y genera el Reporte vehicular solicitado.
                    </span>
                </div>

                <div>
                    <img src={step3} alt="step3" width="100px" height="109px"/>
                    <span>
                        <strong>¡Listo!</strong> El Reporte automotriz podrá consultarlo en el sitio y te lo enviaremos por correo junto al CAV y el MLT.
                    </span>
                </div>
            </div>
        </div>
    );
};
